/**
 * @generated SignedSource<<bf481ededca8d370487263c73985561c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareMeetingModal_postedChannels$data = {
  readonly postedInChannels: ReadonlyArray<{
    readonly id: string;
    readonly isPrivate: boolean;
    readonly members: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly name: string;
  }>;
  readonly " $fragmentType": "ShareMeetingModal_postedChannels";
};
export type ShareMeetingModal_postedChannels$key = {
  readonly " $data"?: ShareMeetingModal_postedChannels$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_postedChannels">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareMeetingModal_postedChannels",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "postedInChannels",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "members",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "feda40a9b8c6ab2b7b95f58a42b4b845";

export default node;
